import { Sport } from '#src/__generated__/globalTypes.ts';
import { useSportContext } from '#src/contexts/sport/index.ts';

import { useFeatureFlags } from './useFeatureFlags.tsx';

export const useEnableProMode = (sportOverride?: Sport) => {
  const { sport: contextSport } = useSportContext();
  const {
    flags: {
      enableProMode = {
        [Sport.BASEBALL]: false,
        [Sport.FOOTBALL]: false,
        [Sport.NBA]: false,
      },
    },
  } = useFeatureFlags();

  return !!enableProMode[sportOverride ?? contextSport];
};
